import { IAddressDetails } from './place-details-v2-response.interface';

/**
 * Interfaces para a resposta V2 do endpoint geocodeBy (geocode-response.interface.ts possui a V1,
 * mantida por compatibilidade com outros consumidores do endpoint).
 *
 * A V2 passou a retornar, além dos address_components "crus" do Google, o objeto "address" já
 * estruturado e tratado pelo backend (addressLine1/2/3/4, city, state, stateCode, postalCode),
 * a mesma estrutura utilizada pelo placeDetailsV2.
 */
export interface IGeocodePlusCodeV2 {
  global_code: string;
}

export interface IGeocodeAddressComponentV2 {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface IGeocodeLocationV2 {
  lat: number;
  lng: number;
}

export interface IGeocodeGeometryV2 {
  location: IGeocodeLocationV2;
}

export interface IGeocodeResultV2 {
  id: string;
  place_id: string;
  formatted_address: string;
  address_components: IGeocodeAddressComponentV2[];
  address: IAddressDetails;
  geometry: IGeocodeGeometryV2;
  types: string[];
}

export interface IGeocodeResponseV2 {
  plus_code: IGeocodePlusCodeV2;
  results: IGeocodeResultV2[];
  status: string;
}
